import { useEffect, useState } from 'react';

interface UseFileUploadPreviewResult {
  previewUrl: string | null;
  isDragOver: boolean;
  setIsDragOver: (value: boolean) => void;
  handleDragOver: (e: React.DragEvent<HTMLDivElement>) => void;
  handleDragLeave: (e: React.DragEvent<HTMLDivElement>) => void;
}

export function useFileUploadPreview(
  value: File | null | undefined,
): UseFileUploadPreviewResult {
  const [previewUrl, setPreviewUrl] = useState<string | null>(null);
  const [isDragOver, setIsDragOver] = useState(false);

  useEffect(() => {
    let objectUrl: string | null = null;
    if (value instanceof File) {
      objectUrl = URL.createObjectURL(value);
      setPreviewUrl(objectUrl);
    } else {
      setPreviewUrl(null);
    }

    return () => {
      if (objectUrl) {
        URL.revokeObjectURL(objectUrl);
      }
    };
  }, [value]);

  const handleDragOver = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragOver(true);
  };

  const handleDragLeave = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragOver(false);
  };

  return {
    previewUrl,
    isDragOver,
    setIsDragOver,
    handleDragOver,
    handleDragLeave,
  };
}
